
import "./Button.css";
import PropTypes from 'prop-types';

export const Button = ({
  btnText,
  containerBtnStyles,
  btnStyles,
  icon,
  width,
  iconPropAlt,
  iconStyles,
  arrowIcon,
  arrowPropAlt,
  arrowStyles,
  handleOnClick,
  handleImgeOnClick,
  handleArrowOnClick,
  disabled,
  process
}) => {
  return (
    <div className={containerBtnStyles}>
      <img
        className={iconStyles}
        src={icon}
        alt={iconPropAlt}
        onClick={handleImgeOnClick}
        width={width}
      />

      <button className={btnStyles} onClick={handleOnClick} disabled={disabled}>
        {process === true ? null: btnText}
      </button>

      <img
        className={arrowStyles}
        src={arrowIcon}
        alt={arrowPropAlt}
        onClick={handleArrowOnClick}
      />
    </div>
  );
};

Button.propTypes = {
  btnText: PropTypes.string,
  containerBtnStyles: PropTypes.string,
  btnStyles: PropTypes.string,
  icon: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), 
  iconPropAlt: PropTypes.string,
  iconStyles: PropTypes.string,
  arrowIcon: PropTypes.string,
  arrowPropAlt: PropTypes.string,
  arrowStyles: PropTypes.string,
  handleOnClick: PropTypes.func,
  handleImgeOnClick: PropTypes.func,
  handleArrowOnClick: PropTypes.func,
  disabled: PropTypes.bool,
  process: PropTypes.bool
};
